import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { XCircle, ArrowRight, Send } from 'lucide-react';

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center animate-fade-in">
        <div className="w-24 h-24 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-red-500" />
        </div>
        
        <h1 className="text-3xl font-bold text-white mb-4">Payment Cancelled</h1>
        <p className="text-gray-400 mb-8">
          Your payment was cancelled. No charges were made to your account.
        </p>

        <div className="flex flex-col gap-4">
          <Link to="/dashboard">
            <Button className="w-full h-14 bg-[#00ff88] text-black font-bold text-lg rounded-lg" data-testid="back-to-dashboard-btn">
              Return to Dashboard
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
          
          <Link to="/">
            <Button variant="ghost" className="w-full text-gray-400 hover:text-white">
              Go to Homepage
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
